export const blockIconsTravelRamenDiningNew = (
	<span className='material-symbols-outlined'>ramen_dining</span>
);
